import {
    array,
    boolean,
    nullable,
    number,
    optional,
    record,
    string,
    type,
    union,
} from "superstruct";

import CartItemSchema from "./CartItemSchema";
import { DiscountCodesSchema } from "./DiscountCodesSchema";
import DiscountSchema from "./DiscountSchema";

export const CartResponseSchema = type({
    token: string(),
    note: nullable(string()),
    attributes: record(
        string(),
        union([
            string(),
            number(),
            boolean(),
            array(string()),
            array(number()),
            array(boolean()),
        ])
    ),
    original_total_price: number(),
    total_price: number(),
    total_discount: number(),
    total_weight: number(),
    item_count: number(),
    items: array(CartItemSchema),
    requires_shipping: boolean(),
    currency: string(),
    items_subtotal_price: number(),
    cart_level_discount_applications: optional(array(DiscountSchema)),
    discount_codes: array(DiscountCodesSchema),
});
